import Popover from '@/Components/UI/Popover/Popover';
import FormulasPopover from '@/Components/FormulaPopover/FormulasPopover';
import Icon from '@/Components/UI/Icon/Icon';

const FormulaPopoverButton = ({ agGrid }) => {
  return (
    <span
      className='absolute z-[1] flex justify-center items-center bg-shadow-200 top-0 right-0 w-6 h-[36px] shadow-[-4px_0px_2px_0px_rgba(133,133,133,0.59)] hover:bg-shadow-300 focus:outline-ocean-blue-200 focus-visible:outline-ocean-blue-200 font-[Overpass]'
      data-cy='formula-button'
    >
      <Popover
        renderComponent={(props) => <FormulasPopover {...props} agGrid={agGrid} />}
        buttonClassname={'!p-0 !w-5 !h-8'}
        panelClassname={'!right-0 !top-9 !w-[640px]'}
        isStatic={false}
        isButtonIcon={false}
        isCloseButton={false}
      >
        <Icon name='plus' color='#151515' />
      </Popover>
    </span>
  );
};

export default FormulaPopoverButton;
